<mat-card class="principal-card">
  <mat-card-header>
    @if (principal?.emailAddress && principalEmail && principal.emailAddress !== principalEmail) {
      <mat-card-subtitle>
        <mat-error>
          Principal Email “{{this.principalEmail}}” does not match and Principal Name from eSOE – “{{principalName}}”
        </mat-error>
      </mat-card-subtitle>
    }
    <mat-card-title>Campus Principal</mat-card-title>
    @if (this.campusName) {
      <mat-card-subtitle>{{this.campusName}}</mat-card-subtitle>
    }
  </mat-card-header>

  <mat-card-content>
    <div>
      <label>Name: </label>
      <span class="name">{{this.principal?.firstName}} {{this.principal?.lastName}}</span>
    </div>

    <div>
      <label>Email: </label>
      <span class="email">
        <a [href]="'mailto:' + principal?.emailAddress">{{this.principal?.emailAddress}}</a>
      </span>
    </div>

    <div>
      <label>Start Date: </label>
      <span class="start-date">{{this.principal?.effectiveBegin | date: 'M/d/yyyy'}}</span>
    </div>
  </mat-card-content>

  <mat-card-actions align="end">
    @if (this.principal) {
      <button mat-stroked-button color="primary" (click)="editPrincipal()">Edit</button>
    }
    @if (this.campusId) {
      <button mat-button mat-raised-button color="primary" (click)="addPrincipal()">Add New</button>
    }
  </mat-card-actions>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  }
</mat-card>
